import { useNavigate } from 'react-router-dom';

const AskAsperRibbonHome = () => {
    const navigate = useNavigate();
    return (
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-[#7341C8] to-[#8E66D2] p-8 shadow-lg">
            <div className="flex items-center justify-between gap-6">
                <div className="flex items-start gap-4 flex-1">
                    <div className="flex-shrink-0 mt-1">
                        <svg
                            className="w-8 h-8 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                            />
                        </svg>
                    </div>
                    <div className="flex-1">
                        <h2 className="text-2xl font-semibold text-white mb-2">
                            Have a question about your portfolio?
                        </h2>
                        <p className="text-purple-100 text-base leading-relaxed">
                            Ask Asper to identify opportunity to simulate business impact across levers of RGM.
                        </p>
                    </div>
                </div>
                <div className="flex-shrink-0">
                    <button
                        className="inline-flex items-center gap-2 px-6 py-3 bg-white text-purple-600 font-medium rounded-lg hover:bg-purple-50 transition-colors shadow-md"
                        onClick={() => {
                            navigate('/ask-asper');
                        }}
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                            />
                        </svg>
                        Start Conversation
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AskAsperRibbonHome;
